import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class MarkQCPass extends Component {
    render(){
        return(
            <div className="dump-ingestion-wrapper">
                <div className="white-box">
                    <div className="page-header-title">
                        Mark QC Dispatch
                    </div>
                    <div>
                        <DownloadFile title="Download Mark QC Dispatch Template" url="ingest/qc-validation/jobs/template"/>
                    </div>
                    <div className="top-thirty">
                        <FileUploaderBlob url="ingest/qc-validation/jobs/trigger"/>
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/QC/Components/MarkQCDispatch.js